/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CredentialRedeemAvailableResponse } from '../../models/credential-redeem-available-response';
import { CredentialRedeemMfaResponse } from '../../models/credential-redeem-mfa-response';
import { CredentialRedeemSsoResponse } from '../../models/credential-redeem-sso-response';
import { CredentialRedeemUnavailableResponse } from '../../models/credential-redeem-unavailable-response';
import { WebProvisionCredentialRedeemRequest } from '../../models/web-provision-credential-redeem-request';

export interface InitiateCredentialRedemption$Params {
      body: WebProvisionCredentialRedeemRequest
}

export function initiateCredentialRedemption(http: HttpClient, rootUrl: string, params: InitiateCredentialRedemption$Params, context?: HttpContext): Observable<StrictHttpResponse<(CredentialRedeemAvailableResponse | CredentialRedeemMfaResponse | CredentialRedeemSsoResponse | CredentialRedeemUnavailableResponse)>> {
  const rb = new RequestBuilder(rootUrl, initiateCredentialRedemption.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(CredentialRedeemAvailableResponse | CredentialRedeemMfaResponse | CredentialRedeemSsoResponse | CredentialRedeemUnavailableResponse)>;
    })
  );
}

initiateCredentialRedemption.PATH = '/webprovision/init';
